import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/teamEvent.css";
import { motion } from "framer-motion";

const EventItem = ({
  id,
  currentId,
  title,
  image,
  description,
  url,
  team,
  schedule,
}) => {
  useEffect(() => {}, []);
  // console.log("Here: " + currentId);
  return (
    <React.Fragment>
      <motion.div
        className="overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 0.5 } }}
        transition={{
          duration: 0.15,
          delay: 0,
        }}
        style={{ pointerEvents: "auto" }}
      >
        <motion.div className="event-content-container open">
          <Link to={`/events/${id}`}></Link>
          <motion.div
            className="event-content mt-100 relative"
            layoutId={`event-container-${currentId}`}
          >
            <motion.div
              className="event-image-container"
              layoutId={`event-image-container-${currentId}`}
            >
              <Link to={`/events/${id}`}></Link>
              <img className="event-image" src={image} alt="" />
            </motion.div>
            <motion.div
              className="title-container"
              layoutId={`title-container-${currentId}`}
            >
              <span className="team-name">{team}</span>
              <h2 className="title">{title}</h2>
              <h3 className="text-base text-gray-500">
                Join us on: {schedule.slice(0, 10)}
              </h3>
            </motion.div>
            <motion.div className="content-container" animate>
              <p>{description}</p>
            </motion.div>
            <div className="w-full">
              <motion.button
                className="timeline-button content-container
                py-1
                px-7
                mt-2
                text-base
                font-medium
                cursor-pointer
                dark:text-white
                text-align:center
                "
                whileHover={{
                  scale: 1.3,
                  boxShadow: "-3px 3px 8px rgba(218,57,159,0.3)",
                }}
                transition={{ type: "spring", stiffness: 500 }}
              >
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="
                    no-underline
                    text-lg
                    font-bold
                    text-gray-700
                    dark:text-gray-300
                  "
                >
                  Find more
                </a>
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </React.Fragment>
  );
};

export default EventItem;
